import MessageBoxMarketerialLayout from './MessageBoxMarketerialLayout';
import MessageBoxFunctionalLayout from './MessageBoxFunctionalLayout';
import HeaderLayout from './HeaderLayout';
import FooterLayout from './FooterLayout';

export { MessageBoxMarketerialLayout, MessageBoxMarketerialLayout as MessageBoxLayout1, HeaderLayout, HeaderLayout as HeaderLayout1, FooterLayout, FooterLayout as FooterLayout1, MessageBoxFunctionalLayout, MessageBoxFunctionalLayout as MessageBoxLayout2 };
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MessageBox/index.js